module.exports = ".donative-fiscal-data {\n  min-height: 80vh;\n  padding-top: 250px; }\n"